<template>
	<div class="index-menu-fluid">
		<div class="layui-container">
			<el-row :gutter="10" type="flex">
				<el-col :span="8">
					<div class="menu-link hover-up">
						<img src="@/assets/images/icon_quality.png" alt="" />
						<div class="flex-col">
							<h4>{{$t('正品')}}</h4>
							<p>{{$t('最好的质量和价格')}}</p>
						</div>
					</div>
				</el-col>
				<el-col :span="8" >
					<div class="menu-link hover-up">
						<img src="@/assets/images/icon_free.png" alt="" />
						<div class="flex-col">
						<h4>{{$t('全部包邮')}}</h4>
						<p>{{$t('平台包邮免运费')}}</p>
						</div>
					</div>
				</el-col>
				<el-col :span="8" >
					<a :href="spRules.meiqia_url" target="_blank" class="menu-link hover-up">
						<img src="@/assets/images/icon_Online.png" alt="" />
						<div class="flex-col">
						<h4>{{$t('在线咨询')}}</h4>
						<p>{{$t('详细而专注的产品咨询支持')}}</p>
						</div>
					</a>
				</el-col>
			</el-row>
			
		</div>
	</div>
</template>

<script>
	import helper from '@/common/helper.js';
	export default {
		data() {
			return {
				spRules: {},
			};
		},
		methods: {
		},
		mounted() {
			this.spRules = this.$helper.get('rule');
		},
	}
</script>